var field = {
  width: '100px',
  display: 'inline-block',
  paddingRight: '6px',
  textAlign: 'left'
}

export const data = () => ({
  pointFormatted: '',
  point: new Date().toISOString(),
  myTimezone: '',
  formComplete: false,
  formData: {},
  loading: true,
  isDebug: true,
  isReadOnly: false,
  meetingRefDateValue: '',
  showFutureDates: false,
  scheduleList: [],

  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    },
    amountField: Object.assign({}, field, {
      width: '125px'
    })
  }
})
